import Text from "@commons/Typography/Text";
import { useUser } from "@hooks/useUser";
import { Backdrop, CircularProgress } from "@mui/material";

function LoadingUser() {
  const { isCheckingUser } = useUser();

  return (
    <Backdrop
      className="z-100 flex flex-col gap-8 justify-center items-center"
      open={isCheckingUser}
    >
      <CircularProgress size={60} />
      <Text>Carregando...</Text>
    </Backdrop>
  );
}

export default LoadingUser;
